"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDgCargoDeclareSearch = getDgCargoDeclareSearch;
exports.getDoucmentCutTime = getDoucmentCutTime;
exports.loadBookingHeadByBLNo = loadBookingHeadByBLNo;
exports.uploadAttach = uploadAttach;
var _request = _interopRequireDefault(require("@/utils/request"));
function getDgCargoDeclareSearch(data) {
  return (0, _request.default)({
    url: '/ebusiness/docDgDeclareCheck/dgCargoDeclareSearch',
    // url: '/webBlConsigneeCertification/add',
    method: 'post',
    data: data
  });
}
function getDoucmentCutTime(data) {
  return (0, _request.default)({
    url: '/ebusiness/docDgDeclareCheck/getDoucmentCutTime',
    // url: '/webBlConsigneeCertification/search',
    method: 'post',
    data: data
  });
}
function uploadAttach(data) {
  return (0, _request.default)({
    url: '/ebusiness/docDgDeclareCheck/uploadAttach',
    method: 'post',
    data: data
  });
}

// 提单号获取提单信息
function loadBookingHeadByBLNo(blNo) {
  return (0, _request.default)({
    url: '/ebusiness/docBookingHead/loadBookingHeadByBLNo/' + blNo,
    method: 'get'
  });
}